import { Divider, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { dateFormat } from '../../../util/DateUtil';
import { currencyRound } from '../../../util/DoubleUtil';
import Button from '../../UI/Button';
import { consultarTransacao, criarTransacaoViaPix } from '../api-lancamento';
import { errorMessage } from '../../../util/ConfirmAlertUtil';
import { Link } from 'react-router-dom';

const LancamentoTableAlunoView = ({ lancamentos, setLancamentos }) => {
    const [isLoadingPixTransacao, setIsLoadingPixTransacao] = useState(false);

    const handleGerarPixQrCode = (lancamento) => {
        setIsLoadingPixTransacao(true);
        criarTransacaoViaPix(lancamento.codigo).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setLancamentos((prevState) => prevState.map((ps) => {
                        if (ps.codigo === lancamento.codigo) {
                            return data;
                        } else {
                            return ps;
                        }
                    }))
                }
            }
            setIsLoadingPixTransacao(false);
        })
    }

    const handleConsultarTransacao = (lancamento) => {
        setIsLoadingPixTransacao(true);
        consultarTransacao(lancamento.codigo).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setLancamentos((prevState) => prevState.map((ps) => {
                        if (ps.codigo === lancamento.codigo) {
                            return data;
                        } else {
                            return ps;
                        }
                    }));
                }
            }
            setIsLoadingPixTransacao(false);
        });
    };

    return (
        <Grid style={{ marginTop: 8 }} container direction='column' spacing={3}>
            {lancamentos.length > 0 ?
                <Grid spacing={3} size={12}>
                    {lancamentos.map((lancamento) => (
                        <>
                            <Grid container
                                style={{
                                    border: '1px solid black',
                                    padding: '20px',
                                    marginTop: '20px',
                                    marginBottom: '20px',
                                    borderRadius: '30px'
                                }}
                                direction='row' spacing={3}>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Ano Letivo: </span>{lancamento.anoLetivo}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Código Documento: </span>{lancamento.codDoc}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Data Emissão: </span>{dateFormat(lancamento.dataEmissao)}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Data Vencimento: </span>{dateFormat(lancamento.dataVencimento)}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Histórico: </span>{lancamento.historicoLancamento.descricao}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Valor: </span>{currencyRound(lancamento.valor)}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Data Desconto: </span>{lancamento.dataDesconto ? dateFormat(lancamento.dataDesconto) : '--'}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Valor Desconto: </span>{lancamento.valorDesconto ? currencyRound(lancamento.valorDesconto) : '--'}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Data Pagamento: </span>{lancamento.dataPagamento ? dateFormat(lancamento.dataPagamento) : '--'}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Valor Pago: </span>{lancamento.valorPago ? currencyRound(lancamento.valorPago) : '--'}</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Código de Barras: </span>{lancamento.codigoBarras ? lancamento.codigoBarras : '--'}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Forma Pago: </span>{lancamento.formaPago ? lancamento.formaPago : '--'}</Typography>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 4,
                                        md: 6,
                                        xs: 12
                                    }}>
                                    <Typography variant='body1'><span style={{ fontWeight: 'bold' }}>Quitado: </span>{lancamento.quitado ? 'Sim' : 'Não'}</Typography>
                                </Grid>

                                {lancamento && !lancamento.quitado ?
                                    <>
                                        <Grid size={12}>
                                            <Divider />
                                        </Grid>
                                        <Grid size={12}>
                                            <Grid container spacing={3} direction="row">
                                                <Grid>
                                                    <Button
                                                        disabled={isLoadingPixTransacao}
                                                        onClick={() => handleGerarPixQrCode(lancamento)}
                                                    >
                                                        Gerar Pix Qr Code
                                                    </Button>
                                                </Grid>


                                                <Grid>
                                                    <Button
                                                        disabled={isLoadingPixTransacao}
                                                        onClick={() => handleConsultarTransacao(lancamento)}
                                                    >
                                                        Verificar Pagamento
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {lancamento.pixTransacao && (
                                            <Grid>
                                                <Typography variant='h6'>Pix</Typography>
                                                <Typography>
                                                    {lancamento.pixTransacao &&
                                                        lancamento.pixTransacao.qrCodeTexto
                                                        ? lancamento.pixTransacao.qrCodeTexto
                                                        : ""}
                                                </Typography>
                                                <img
                                                    alt=""
                                                    src={
                                                        lancamento.pixTransacao &&
                                                            lancamento.pixTransacao.qrCodeImagem
                                                            ? lancamento.pixTransacao.qrCodeImagem
                                                            : null
                                                    }
                                                />
                                            </Grid>
                                        )}
                                    </> : <></>}
                                {lancamento && !lancamento.quitado && lancamento.aceitaCartaoCredito ?
                                    <>
                                        <Grid size={12}>
                                            <Divider />
                                        </Grid>
                                        <Grid size={12}>
                                            <Grid container spacing={3} direction="row">
                                                <Grid>
                                                    <Button
                                                        component={Link}
                                                        to={"/lancamento/pagamento-por-cartao-credito/" + lancamento.codigo}

                                                    >
                                                        Pagar com Cartão de Crédito
                                                    </Button>
                                                </Grid>



                                            </Grid>
                                        </Grid>


                                    </> : <></>}



                            </Grid>
                        </>

                    ))}
                </Grid>
                : ''
            }
        </Grid>
    );
}

export default LancamentoTableAlunoView;